import React, { useState, useEffect } from "react";
import {
  useColorMode,
  Container,
  Box,
  Center,
  Text,
  useToast,
  HStack,
  Button,
} from "@chakra-ui/react";
import { toChecksumAddress } from "ethereum-checksum-address";
import axios from "axios";
import { generateSolidity } from "abi-to-sol";
import networkInfo from "./networkInfo";
import AddressInput from "./AddressInput";
import JsonTextArea from "../common/JsonTextArea";
import { CopyIcon } from "@chakra-ui/icons";

function Body() {
  const { colorMode } = useColorMode();
  const bgColor = { light: "white", dark: "gray.700" };
  const toast = useToast();

  const [contractAddress, setContractAddress] = useState("");
  const [networkIndex, setNetworkIndex] = useState(0);
  const [abi, setAbi] = useState("");
  const [solInterface, setSolInterface] = useState("");

  const [isFetchingABI, setIsFetchingABI] = useState(false);

  const fetchABIFromAddress = async () => {
    setIsFetchingABI(true);

    // get ABI
    let fetched_abi;
    // from Sourcify
    try {
      const response = await axios.get(
        `https://repo.sourcify.dev/contracts/full_match/${
          networkInfo[networkIndex].chainID
        }/${toChecksumAddress(contractAddress)}/metadata.json`
      );
      fetched_abi = JSON.stringify(response.data.output.abi);
    } catch {
      // from Etherscan API
      const response = await axios.get(networkInfo[networkIndex].api, {
        params: {
          address: contractAddress,
        },
      });

      if (response.data.message === "OK") {
        fetched_abi = response.data.result;
      } else {
        toast({
          title: "ABI Not found",
          status: "error",
          isClosable: true,
          duration: 2000,
        });
      }
    }

    setIsFetchingABI(false);

    setAbi(JSON.stringify(JSON.parse(fetched_abi), undefined, 2));
    toast({
      title: "Solidity Interface generated",
      status: "success",
      isClosable: true,
      duration: 1000,
    });
  };

  useEffect(() => {
    if (abi) {
      setSolInterface(
        generateSolidity({
          abi: JSON.parse(abi),
        })
      );
    }
  }, [abi]);

  return (
    <Box my="16" minW={["0", "0", "2xl", "2xl"]}>
      <Container>
        <AddressInput
          contractAddress={contractAddress}
          setContractAddress={setContractAddress}
          networkInfo={networkInfo}
          networkIndex={networkIndex}
          setNetworkIndex={setNetworkIndex}
          btnDisabled={false}
          fetchABI={fetchABIFromAddress}
          isFetchingABI={isFetchingABI}
          bg={bgColor[colorMode]}
        />
      </Container>
      <Center flexDir={"column"} mt="1rem">
        <Box>
          <HStack mb="0.5rem">
            <Text>Output</Text>
            <Button
              onClick={() => {
                navigator.clipboard.writeText(solInterface);
                toast({
                  title: "Copied to clipboard",
                  status: "success",
                  isClosable: true,
                  duration: 1000,
                });
              }}
              size="sm"
            >
              <CopyIcon />
            </Button>
          </HStack>
          <JsonTextArea
            value={solInterface}
            readOnly={true}
            ariaLabel="JSON ABI"
            canResize={true}
          />
        </Box>
      </Center>
    </Box>
  );
}

export default Body;
